<div [ngClass]="[device.isMobile && !device.isTablet ? 'sk-bg-event-mobile sk-p-12' : 'sk-bg-event-desk']">
    <div class="sk-event-tournament sk-b-rad4 sk-h-12"></div>
    <div class="sk-event-team-name sk-b-rad4 sk-h-12"></div>
    <div class="sk-event-score sk-b-rad4 sk-h-12"></div>
</div>
@if (device.isMobile && !device.isTablet) {
    <div class="sk-event-marquee">
        <ms-skeleton-marquee />
    </div>
}
<div class="sk-event-main-head">
    @for (elistId of [1, 2, 3, 4, 5, 6, 7, 8, 9]; track elistId) {
        <div [ngClass]="!device.isMobile ? 'sk-event-cards' : 'sk-event-cards sk-event-cards-mobile'">
            <div class="sk-event-header sk-b-rad5 sk-m-right12 sk-event-market-header1">
                <div class="sk-event-card-head sk-b-rad5">
                    <div class="sk-event-grid-title sk-h-12 sk-b-rad8"></div>
                </div>
                <div class="sk-event-market-name sk-h-12 sk-b-rad4"></div>
                @if (getEventOrderId(elistId)) {
                    <div class="sk-event-team">
                        <div class="sk-event-player sk-h-12 sk-b-rad4"></div>
                        <div class="sk-event-player-odds sk-h-12 sk-b-rad4"></div>
                    </div>
                    <div class="sk-event-team">
                        <div class="sk-event-player sk-h-12 sk-b-rad4 sk-event-second"></div>
                        <div class="sk-event-player-odds sk-h-12 sk-b-rad4"></div>
                    </div>
                    <div class="sk-event-team">
                        <div class="sk-event-player sk-h-12 sk-b-rad4 sk-event-third"></div>
                        <div class="sk-event-player-odds sk-h-12 sk-b-rad4"></div>
                    </div>
                } @else {
                    @for (i of [0, 1, 2]; track i) {
                        <div class="sk-event-team-second">
                            <div class="sk-event-player-second sk-h-12 sk-b-rad4"></div>
                            <div class="sk-event-player-second sk-h-12 sk-b-rad4 sk-event-second-market"></div>
                            <div class="sk-event-player-second sk-h-12 sk-b-rad4 sk-event-second-market sk-event-player-third"></div>
                        </div>
                    }
                }
            </div>
        </div>
    }
</div>
